import { Box } from "@mui/material"
import { BulkDeleteDialog } from "@/components/ui/bulk-delete-dialog"

interface Customer {
  id: string | number
  full_name?: string
  company_name?: string
  email?: string
}

interface BulkDeleteCustomerModalProps {
  isOpen: boolean
  onClose: () => void
  selectedCustomers: Customer[]
  onConfirmDelete?: (customerIds: string[]) => Promise<void>
}

export function BulkDeleteCustomerModal({
  isOpen,
  onClose,
  selectedCustomers,
  onConfirmDelete,
}: BulkDeleteCustomerModalProps) {
  return (
    <BulkDeleteDialog
      isOpen={isOpen}
      onClose={onClose}
      items={selectedCustomers}
      entityLabel={{ singular: "Customer", plural: "Customers" }}
      subtitle="They leave the lists; the records are kept"
      // crm-api `customers#bulk_delete` calls `soft_delete!` per row — the rows
      // leave the default scope; no deal, note, activity or file is touched.
      cascadingWarning="This marks all selected customers as deleted, so they leave the customer lists, search and reports. Their deals, notes, activities and files are preserved, and the records are kept — an administrator can restore them."
      renderItem={(c) => (
        <>
          {c.full_name || c.company_name || `Customer ${c.id}`}
          {c.company_name && c.full_name && (
            <Box component="span" sx={{ color: "error.main" }}> ({c.company_name})</Box>
          )}
        </>
      )}
      onConfirm={async (ids) => {
        if (onConfirmDelete) await onConfirmDelete(ids)
      }}
    />
  )
}
